module.exports = __webpack_public_path__ + "img/evaluate-data-export.7cee3545.svg";